// Usage: {{ modifier | modifierChoices }}
function modifierChoices(modifier) {
  return modifier?.choices.map(c => {
    if (c.price) return c.name + " $" + c.price;
    else return c.name;
  }).join(", ");
}
export default modifierChoices